import { useState } from 'react'
import './SignUp.css'
import { signUp } from '../../services/users'
import { useNavigate } from 'react-router-dom'
import Layout from '../../components/Layout/Layout';

const SignUp = (props) => {
  const history = useNavigate()


  const [form, setForm] = useState({
    username: '',
    email: '',
    password: '',
    passwordConfirmation: '',
    isError: false,
    errorMsg: '',
  })

  const handleChange = (event) =>
    setForm({
      ...form,
      [event.target.name]: event.target.value,
    })

  const onSignUp = async (event) => {
    event.preventDefault()
    const { setUser } = props
    try {
      const user = await signUp(form)
      setUser(user)
      history('/gallery')
    } catch (error) {
      console.error(error)
      setForm({
        username: '',
        email: '',
        password: '',
        passwordConfirmation: '',
        isError: true,
        errorMsg: 'Sign Up Details Invalid',
      })
    }
  }

  const renderError = () => {
    const toggleForm = form.isError ? 'danger' : ''
    if (form.isError) {
      return (
        <button id="button" type='submit' className={toggleForm}>
          {form.errorMsg}
        </button>
      )
    } else {
      return <button id="button" type='submit'>Sign Up</button>
    }
  }

  const { username, email, password, passwordConfirmation } = form

  return (
    <div>
      <Layout>
    <div className='form-container'>
      <h3>Sign Up</h3>
      <form onSubmit={onSignUp}>
        {/* <label>Username</label> */}
        <input
          id="username"
          required
          type='text'
          name='username'
          value={username}
          placeholder='Enter username'
          onChange={handleChange}
        />
        {/* <label>Email address</label> */}
        <input
          id="email"
          required
          type='email'
          name='email'
          value={email}
          placeholder='Enter email'
          onChange={handleChange}
        />
        {/* <label>Password</label> */}
        <input
          id="password"
          required
          name='password'
          value={password}
          type='password'
          placeholder='Password'
          onChange={handleChange}
        />
        {/* <label>Password Confirmation</label> */}
        <input
          id="password1"
          required
          name='passwordConfirmation'
          value={passwordConfirmation}
          type='password'
          placeholder='Confirm Password'
          onChange={handleChange}
        />
        {renderError()}
      </form>
    </div>
    </Layout>
    </div>
  )
}

export default SignUp
